export default __webpack_public_path__ + "static/military-c42210416a9ab8a273302fd8352b9ca7.jpg";